var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h1',[_vm._v("Page Not Found")]),_c('p',{staticClass:"text-center"},[_vm._v(" We're sorry, but the page you're trying to access does not exist. We apologize for this inconvenience. ")])])
}]

export { render, staticRenderFns }